const myCenterRouters = [
  {
    path: '/MyCenter',
    name: 'myCenter',
    component: () => import('../views/myCenter/index.vue'),  // 懒加载
    redirect:'/MyCenter/mine',
    children:[
      {
        path: 'mine',
        name: 'mine',
        component: () => import('../views/myCenter/child/mine.vue'),  // 懒加载
        meta: {
          isCorrectPage: true,
          auth: false
        }
      },//个人中心 - 切换宝宝
      {
        path: 'rewardSource',
        name: 'rewardSource',
        component: () => import('../views/myCenter/child/rewardSource.vue'),  // 懒加载
        meta: {
          isCorrectPage: true,
          auth: false
        }
      },//个人中心 - 奖励来源
      {
        path: 'learnCount',
        name: 'learnCount',
        component: () => import('../views/myCenter/child/learnCount.vue'),  // 懒加载
        meta: {
          isCorrectPage: true,
          auth: false
        }
      },//个人中心 - 学习统计
      {
        path: 'learnTrack',
        name: 'learnTrack',
        component: () => import('../views/myCenter/child/learnTrack.vue'),  // 懒加载
        meta: {
          isCorrectPage: true,
          auth: false
        }
      },//个人中心 - 学习轨迹
      {
        path: 'setting',
        name: 'setting',
        component: () => import('../views/myCenter/child/setting.vue'),  // 懒加载
        meta: {
          isCorrectPage: true,
          auth: false
        }
      },//个人中心 - 设置
    ]
  },//个人中心 - 切换宝宝
]

export default myCenterRouters;